exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".middle[data-v-73c48787]{padding:2px 4px 2px 2px}.name[data-v-73c48787]{font-weight:800}.description[data-v-73c48787]{font-size:13px;margin-right:4px}.address-title[data-v-73c48787],.follow_us[data-v-73c48787]{font-size:14px;font-weight:800}.follow_us[data-v-73c48787]{position:relative}.nutri-grade-scale[data-v-73c48787]{position:absolute;left:-76px;top:0}.icon[data-v-73c48787]{margin-top:3px;margin-right:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73c48787","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RestaurantInfo.vue
// module id = 89Jq
// module chunks = 0